import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M4 19h6a2 2 0 0 0 2 -2v-10a2 2 0 0 1 2 -2h7","key":"svg-0"}]]

/**
 * IconStrokeDynamic
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItc3Ryb2tlLWR5bmFtaWMiCj4KICA8cGF0aCBzdHJva2U9Im5vbmUiIGQ9Ik0wIDBoMjR2MjRIMHoiIGZpbGw9Im5vbmUiIC8+CiAgPHBhdGggZD0iTTQgMTloNmEyIDIgMCAwIDAgMiAtMnYtMTBhMiAyIDAgMCAxIDIgLTJoNyIgLz4KPC9zdmc+) - https://tabler.io/icons/icon/stroke-dynamic
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconStrokeDynamic = createReactComponent('outline', 'stroke-dynamic', 'StrokeDynamic', __iconNode);

export default IconStrokeDynamic;